import { MdArrowDownward, MdArrowUpward } from 'react-icons/md';

import styles from './MarketSharePotentialGain.module.scss';

type MarketSharePotentialGainProps = {
  value: number;
};

const formatPointsPerPercent = (value: number) => `${value?.toFixed(1).replace('.', ',')} p.p`;

export const MarketSharePotentialGain = ({ value }: MarketSharePotentialGainProps) => {
  if (value === null || value === undefined || Math.abs(value) < 0.1) {
    return <span className={styles.textZero}>00,0%</span>;
  }

  const isPositive = value > 0;

  return (
    <div className={styles.wrapper}>
      {isPositive ? <MdArrowUpward size={16} color="#33AB84" /> : <MdArrowDownward size={16} color="#FF4D4F" />}
      <span className={styles[isPositive ? 'textPositive' : 'textNegative']}>{formatPointsPerPercent(value)}</span>
    </div>
  );
};
